module.exports = ".backdrop {\n  background-color: rgba(0, 0, 0, 0.6);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh; }\n\n.modalImgpanel {\n  top: 0;\n  left: 0;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main